import {
  Box,
  Grid,
  HStack,
  Stack,
  Heading,
  List,
  ListItem,
  useDisclosure,
  Text,
  Button as CButton,
  VStack,
  CircularProgress,
} from "@chakra-ui/react";

import { useMemo } from "react";
// import { ChevronRightIcon } from "@chakra-ui/icons";

// import { useParams } from "react-router-dom";
import { CgDatabase } from "react-icons/cg";

//Components
// import Header from "components/dashHeader";
// import Sidemenu from "components/sidemenu";
import Button from "components/Button/Button";
import PriceChart from "components/Charts/PriceChart";
// import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";
import WalletActions from "components/WalletActions/WalletActions";

// import { ReactComponent as SampleChart } from "assets/svg/sample-wallet-chart.svg";

import { useHistory } from "react-router-dom";

// import toUpper from "lodash/toUpper";
import toLower from "lodash/toLower";
import { format, parseISO } from "date-fns";
import toPrecision from "util/toPrecision";

import { useGetWalletTransationsQuery } from "services/walletApi";
import { useGetCoinToUsdRateQuery } from "services/rateApi";
import useWallet from "hooks/useWalletBalance";
// import constants from "config/constant";

export const TransactionItem = ({
  type,
  currency,
  description,
  createdAt,
  value,
  transactionId,
}) => {
  const { /*isOpen, onClose,*/ onOpen } = useDisclosure();

  // console.log("transaction id", transactionId);

  const getColor = (type) => {
    const map = {
      credit: "#00BA88",
      debit: "#ED2E7E",
    };

    return map[toLower(type) ?? "credit"];
  };

  const getType = (type) => {
    const map = {
      [toLower(type)]: toLower(type).includes("debit") ? "debit" : "credit",
      contract_credit: "credit",
      contract_debit: "debit",
    };

    return map[toLower(type)];
  };

  return (
    <>
      <ListItem
        w="100%"
        as={CButton}
        minH="fit-content"
        bg="transparent"
        p="32px 0"
        borderRadius="2px"
        borderBottom={
          // i !== items.length - 1 ? "1px solid #D9DBE9" : "none"
          "1px solid #EAEAEA"
        }
        _hover={{ bg: "transparent" }}
        _active={{ bg: "transparent" }}
        _focus={{ bg: "transparent", shadow: "0 0 0 3px var(--focusColor)" }}
        onClick={onOpen}
        whiteSpace="normal"
      >
        <HStack justifyContent="space-between" w="100%" px="4px">
          <HStack alignItems="flex-start">
            <Box
              mt="6px !important"
              borderRadius="50%"
              boxSize="10px"
              bg={getColor(getType(type))}
            />
            <Box maxW="180px">
              <Text
                textAlign="left"
                fontSize="sm"
                fontWeight="500"
                color="#595B67"
                w="100%"
                whiteSpace="nowrap"
                textOverflow="ellipsis"
                overflow="hidden"
                m="0 !important"
              >
                {description}
              </Text>
              <Text textAlign="left" fontSize="12px" mt="2px">
                {format(parseISO(createdAt), "eee, dd MMM yyyy, HH:mm")}
              </Text>
            </Box>
          </HStack>

          <Text>
            {getType(type) === "debit" ? "-" : ""}
            {/* {formatter(currency).format(value?.$numberDecimal)} */}
            {toPrecision(value?.$numberDecimal, currency)}
          </Text>
        </HStack>
      </ListItem>

      {/* <TransactionDetailModal
          type={type}
          description={description}
          amount={value?.$numberDecimal}
          createdAt={createdAt}
          currency={currency}
          txId={transactionId}
          title={`${description} Details`}
          onClose={onClose}
          isOpen={isOpen}
        /> */}
    </>
  );
};

const WalletDetailsChart = ({ coin }) => {
  return (
    <Box
      bg="white"
      border="1px solid #EFF0F6"
      py="30px"
      borderRadius="16px"
      minW="420px"
      w="100%"
    >
      {/* <Box w="420px" as={SampleChart} /> */}
      <PriceChart coin={coin} />
    </Box>
  );
};

const WalletDetailsTransactions = ({ coin }) => {
  const history = useHistory();
  const { data, isLoading, isFetching } = useGetWalletTransationsQuery(coin);

  const transactions = useMemo(() => data?.transactions, [data]);

  return (
    <Box
      bg="white"
      border="1px solid #EFF0F6"
      p="32px"
      borderRadius="16px"
      w="100%"
      flex="1"
      // maxW="420px"
    >
      <HStack
        justifyContent="space-between"
        borderBottom="1px solid #D4D2D2"
        pb="14px"
      >
        <Heading fontSize="18px">Transactions</Heading>
        {transactions?.length > 1 && !isLoading && !isFetching && (
          <Button
            //   disabled={!isEligible}
            variant="ghost"
            bg="transparent"
            size="sm"
            color="#03A438"
            minW="fit-content"
            onClick={() =>
              history.push(`/dashboard/wallet/${coin}/transactions`)
            }
          >
            {/* <HStack>
            <Box as={AddCircleIcon} />
            <Text>Request Card</Text>
          </HStack> */}
            View all
          </Button>
        )}
      </HStack>

      {transactions?.length < 1 && !isLoading && !isFetching && (
        <VStack py="32px">
          <Box as={CgDatabase} fontSize="48px" color="grey" />
          <Text color="grey">No Data</Text>
        </VStack>
      )}

      {isFetching && (
        <VStack py="32px">
          <CircularProgress
            ml="20px !important"
            isIndeterminate
            color="var(--primary)"
            size="20px"
          />
        </VStack>
      )}

      {transactions && !isLoading && (
        <List mt="12px">
          {transactions?.map((tx, i) => (
            <TransactionItem
              // type="credit"
              // currency="btc"
              // description="Fund wallet"
              // createdAt="2021-11-23T10:07:59.897Z"
              // value={{ $numberDecimal: "2000" }}
              key={`transaction-item-${i}`}
              {...tx}
              transactionId={tx?._id}
              currency={tx?.unit}
            />
          ))}
        </List>
      )}
    </Box>
  );
};

export default function CryptoDetailsOverview({ coin }) {
  const { getCoin, isLoading } = useWallet();

  const _coin = useMemo(() => {
    const map = {
      [coin]: coin,
      tbtc: "btc",
      teth: "eth",
      usdt: "usd",
      celo: "celo",
      cusd: "usd",
      ceur: "eur",
    };

    return map[coin];
  }, [coin]);

  const { data: rate, isLoading: isRating } = useGetCoinToUsdRateQuery(_coin, {
    skip: coin?.includes("usd"),
  });

  return (
    <Grid
      mt="20px"
      alignItems="flex-start"
      templateColumns={["1fr", "1fr", "repeat(2, 1fr)"]}
      gridGap="8px"
    >
      <Stack w="100%">
        <WalletActions
          isLoading={isLoading}
          coin={coin}
          data={getCoin(coin)}
          rate={rate?.exchangeRate?.buy ?? 1}
          isRating={isRating}
        />

        <WalletDetailsChart coin={coin} />
      </Stack>

      <WalletDetailsTransactions coin={coin} />
    </Grid>
  );
}
